export default __webpack_public_path__ + "static/media/gift3.d08279aa.png";